var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainfall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.99 19.633 2.122 2.12-.796.796-2.12-2.12.795-.796Zm-4.5 0 2.122 2.12-.796.796-2.12-2.12.795-.796Zm9.056-.133 2.12 2.121-.795.796-2.121-2.122.796-.795ZM5.99 16.633l2.12 2.12-.795.796-2.12-2.12.795-.796Zm4.61-.266 2.12 2.122-.795.795-2.121-2.121.795-.796Zm4.5 0 2.12 2.122-.795.795-2.121-2.121.795-.796Zm4.39-.484 2.12 2.12-.795.796-2.12-2.12.795-.796ZM14.25 0a5.25 5.25 0 0 1 5.197 6h.428A4.125 4.125 0 0 1 24 10.125v.75A4.125 4.125 0 0 1 19.875 15H4.125A4.125 4.125 0 0 1 0 10.875v-.75A4.125 4.125 0 0 1 4.125 6H4.5a3 3 0 0 1 4.772-2.421A5.25 5.25 0 0 1 14.25 0Z",
    fill: "#000",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainfall);
export default __webpack_public_path__ + "static/media/rainfall.b60870c1ba31dd7d5374d559678a4225.svg";
export { ForwardRef as ReactComponent };